/**
 * @generated SignedSource<<55d7a58261cac18c94c8852192126830>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PendingExcessChargesQuery$variables = {};
export type PendingExcessChargesQuery$data = {
  readonly myExcessCharges: ReadonlyArray<{
    readonly computedState: string;
  }>;
};
export type PendingExcessChargesQuery = {
  response: PendingExcessChargesQuery$data;
  variables: PendingExcessChargesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "computedState",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PendingExcessChargesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ExcessOrderCharge",
        "kind": "LinkedField",
        "name": "myExcessCharges",
        "plural": true,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PendingExcessChargesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ExcessOrderCharge",
        "kind": "LinkedField",
        "name": "myExcessCharges",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "35b753341d07fcc5acbe6ca05b88f832",
    "id": null,
    "metadata": {},
    "name": "PendingExcessChargesQuery",
    "operationKind": "query",
    "text": "query PendingExcessChargesQuery {\n  myExcessCharges {\n    computedState\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "330128056633785614f5bfff43817a57";

export default node;
